/*
Zarządzanie usługami w edycji firmy. Dodaje obsługę accordiona. Po zaznaczeniu checkboxa w tytule panelu accordiona
rozwija dany panel. Gdy checkbox jest odznaczony, panel jest ukryty.

Dostępne metody:
ApiServicesAccordion.init() - odpalenie skryptu
*/
class ApiServicesAccordion {
    static init() {
        ApiServicesAccordion.#initAccordion();
        ApiServicesAccordion.#validation();
    }

    static #initAccordion() {
        $('.accordion .panel-title input[type=checkbox]').each(function() {
            if ($(this).is(':checked')) {
                $(this).closest('.panel-heading').parent().find('.panel-collapse').addClass('in');
            } else {
                $(this).closest('.panel-heading').parent().find('.panel-collapse').removeClass('in');
            }

            // noinspection JSUnusedLocalSymbols
            $(this).on('click', function(e) {
                $(this).closest('.panel').find('.panel-collapse').collapse('toggle');
            });
        });
    }

    static #validation() {
        const $list = $('#ddosNotificationEmailsList');
        const mailReg = /^[0-9a-z_.-]+@[0-9a-z.-]+\.[a-z]{2,3}$/i;
        const $serviceOne = $('#serviceOne');

        //walidacja tylko jak jest
        $('#servicesConfig').on('submit', function(e) {
            if ($serviceOne.prev().find('input:checkbox:checked').length) {
                let hasBadEmails = false;
                $list.find('input:text').each(function () {
                    const $this = $(this);
                    if (!mailReg.test($this.val())) {
                        $(this).parent().parent().addClass('has-error');
                        hasBadEmails = true;
                    } else {
                        $(this).parent().parent().removeClass('has-error');
                    }
                });


                if (hasBadEmails) {
                    e.preventDefault();
                    $('html, body').animate({scrollTop: $serviceOne.parent().parent().offset().top - 70}, 1000);
                }
            }
        });

        $list.find('input:text').on('blur', function() {
            const $this = $(this);
            if (!mailReg.test($this.val())) {
                $(this).parent().parent().addClass('has-error');
            } else {
                $(this).parent().parent().removeClass('has-error');
            }
        });
    }
}
